import { pagesConfig } from '../../../shared/pages-config';
import RoleManagerGrid from './role-manager-grid';
import { useUserSettings } from '../../../utils/use-user-settings';
import { useParams } from 'react-router-dom';
import { Outlet } from 'react-router-dom';
import SimpleBreadcrumbsPage from '../../../shared/simple-breadcrumbs-page';
import { ModuleList } from '../../../shared/analytics/module-list';

export default function RoleManagerPage() {
  const { changeLogRoles, administrationRoles } = useUserSettings();
  const { roleName } = useParams() as { roleName: string | undefined };

  if (roleName) {
    return <Outlet />;
  }

  return (
    <SimpleBreadcrumbsPage
      breadcrumbs={[
        { label: ModuleList.modules.administration.name },
        { label: pagesConfig.roleManager.name },
      ]}
      bookmarkKey={pagesConfig.roleManager.value}
    >
      <RoleManagerGrid
        administrationRoles={administrationRoles}
        changeLogRoles={changeLogRoles}
      />
    </SimpleBreadcrumbsPage>
  );
}
